import React from "react";
import { useSelector } from "react-redux";
import { useLottie } from "lottie-react";
import Empty from "constants/lottiesFiles/nopost.json";

const options = {
  loop: true,
  autoplay: true,
  animationData: Empty,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

function EmptyTableAnimation({ data, handleOnClick, height }) {
  const { serviceCallStatus } = useSelector((state) => state);

  const { View } = useLottie(options, { height: !height ? "100%" : height, width: "100%" });

  return !(serviceCallStatus > 0) && (!data || data.length === 0) ? (
    <div className="d-flex h-100 w-100 p-8">
      <div className="m-auto align-self-center" onClick={handleOnClick && handleOnClick}>
        {View}
      </div>
    </div>
  ) : null;
}

export default EmptyTableAnimation;
